import { Toolbar } from '@mui/material'
import { HorizontalTabLayout } from '../../components'
import { OWNINFO_TAB_PROPS } from './constants'

type OwnInformationProps = {
  openTab: string
}

export const OwnInformation = ({ openTab }: OwnInformationProps) => {
  return (
    <>
      <HorizontalTabLayout openTab={openTab} tabProps={OWNINFO_TAB_PROPS} />
      <Toolbar />
    </>
  )
}
